// extracted by mini-css-extract-plugin
export default {"img":"ImageForFour_img__Ii6V6"};